import React, { Component } from 'react';
import './TripPanelTable.css';

import AirModalCarousel from '../../../../../../common/components/AirModalCarousel';
import AirTable from '../../../../../../common/components/AirTable';
import { ExternalLinkIcon, DayIcon, NightIcon } from '../../../../../../common/icons';
import { api } from '../../../../../../services';
import moment from 'moment';
import { inject, observer } from 'mobx-react';
import TripCarouselContent from './TripCarouselContent';
import { utils } from '../../../../../../helpers';

@inject('translationsStore')
@observer
export default class TripPanelTable extends Component {
  constructor(props) {
    super(props);
    this.AirModalCarouselRef = React.createRef();
    this.state = {};
  }

  handleOneDayJourneysResponse = ({ record, journeys, summary }) => {
    const { journeyDate } = record;
    let dayJourneys = journeys.sort((j1, j2) => utils.sortDate(j1.startAt, j2.startAt));
    api('getRpm', this.props.carId, moment(journeyDate).format('YYYY-MM-DD'), moment(journeyDate).format('YYYY-MM-DD'))
      .then(rawOverRpms => {
        return rawOverRpms;
      })
      .catch(() => {})
      .then(rawOverRpms => {
        summary = { ...summary, totalOverRpms: rawOverRpms.rpms.length };
        dayJourneys = dayJourneys.map(journey => {
          let journeyOverRpms = rawOverRpms.rpms;
          journeyOverRpms = journeyOverRpms.filter(rpm => rpm.startDateTime >= journey.startAt && rpm.endDateTime <= journey.endAt);
          return { ...journey, overRpms: journeyOverRpms };
        });
        this.setState({
          journeyLoading: false,
          dayJourneys,
          journeyDate,
          summary
        });
      });
  };

  render() {
    const { translationsStore, carId } = this.props;
    return (
      <React.Fragment>
        <AirTable
          className="TripPanelTable"
          pageSize={5}
          columns={[
            {
              align: 'center',
              dataIndex: 'journeyDate',
              key: 'journeyDate',
              title: translationsStore.translate('tripsPanel.table.column.journeyDate')
            },
            {
              align: 'center',
              dataIndex: 'distance',
              key: 'distance',
              title: translationsStore.translate('tripsPanel.table.column.distance'),
              render: distance => distance + ' Km'
            },
            {
              align: 'center',
              dataIndex: 'durationInSecond',
              key: 'durationInSecond',
              title: translationsStore.translate('tripsPanel.table.column.durationInSecond'),
              render: durationInSecond => moment.duration(durationInSecond || 0, 'seconds').format('h:mm:ss [h]', { trim: false })
            },
            {
              align: 'center',
              dataIndex: 'dayDrivePercentage',
              key: 'dayDrivePercentage',
              title: translationsStore.translate('tripsPanel.table.column.dayDrivePercentage'),
              render: (dayDrivePercentage, record) => (
                <div className="daydrive">
                  <div>
                    <DayIcon />
                    {Math.round(dayDrivePercentage / record.noOfJourney)}%
                  </div>
                  <div>
                    <NightIcon />
                    {100 - Math.round(dayDrivePercentage / record.noOfJourney)}%
                  </div>
                </div>
              )
            },
            {
              align: 'center',
              dataIndex: 'rating',
              key: 'rating',
              title: translationsStore.translate('tripsPanel.table.column.rating'),
              render: (rating, record) => Math.round((rating || 0) / (record.noOfJourney || 1))
            },
            {
              align: 'center',
              dataIndex: 'id',
              key: 'id',
              className: 'gotodetaillink',
              render: (id, record) => {
                return (
                  <ExternalLinkIcon
                    onClick={() => {
                      this.setState({ showDetail: true, journeyLoading: true });
                      api('get one day journeys', carId, moment(record.journeyDate).format('YYYY-MM-DD')).then(({ journeys, summary }) => {
                        this.handleOneDayJourneysResponse({ record, journeys, summary });
                      });
                    }}
                  />
                );
              }
            }
          ]}
          dataSource={this.props.journeys}
        />
        <AirModalCarousel
          loading={this.state.journeyLoading}
          loadingMessage={translationsStore.translate('tripsPanel.table.detail.loadingMessage')}
          height={570}
          current={0}
          width={840}
          visible={this.state.showDetail}
          items={this.state.dayJourneys}
          onCancel={() => this.setState({ dayJourneys: [], showDetail: false, journeyDate: undefined })}
          header={() => (
            <div>
              {translationsStore.translate('tripsPanel.table.detail.header')} {new Date(this.state.journeyDate).toLocaleDateString()}
            </div>
          )}
          renderContent={(item, index, items) => {
            if (item) {
              const { startAt, endAt, distance, duration, overDrives, rating, brakes, accelerations, crashEvents } = item;
              let { overRpms: overRpmsWithPositions } = item;
              const positions = item.positions.map(position => position.loc);
              overRpmsWithPositions = overRpmsWithPositions.map(overRpm => {
                const {
                  coordinates: [startPosition_lng, startPosition_lat]
                } = overRpm.startPosition;
                const {
                  coordinates: [endPosition_lng, endPosition_lat]
                } = overRpm.endPosition;
                return {
                  ...overRpm,
                  startPosition: { lat: startPosition_lat, lng: startPosition_lng },
                  endPosition: { lat: endPosition_lat, lng: endPosition_lng }
                };
              });
              const overRpms = overRpmsWithPositions.length;
              return (
                <TripCarouselContent
                  index={index}
                  total={items.length}
                  carId={carId}
                  plate={this.props.plate}
                  trip={item}
                  positions={positions}
                  overRpmsWithPositions={overRpmsWithPositions}
                  summary={{ startAt, endAt, distance, duration, overDrives, rating, brakes, accelerations, crashEvents, overRpms }}
                  serviceLevel={this.props.serviceLevel}
                />
              );
            }
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/TripPanel/TripPanelTable/TripPanelTable.js